import React, { createContext, useContext, useState, useEffect } from 'react';
import { formConfig } from '../config/formConfig';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [currentThemeId, setCurrentThemeId] = useState(formConfig.app.defaultTheme);
  const theme = formConfig.themes.themes.find(t => t.id === currentThemeId) || formConfig.themes.themes[0];

  useEffect(() => {
    const root = document.documentElement;
    const colors = theme.colors;
    Object.keys(colors).forEach(key => {
      root.style.setProperty(`--${key}`, colors[key]);
    });
    
    // Set component tokens
    const components = theme.components;
    if (components) {
      Object.keys(components).forEach(comp => {
        Object.keys(components[comp]).forEach(prop => {
          root.style.setProperty(`--${comp}-${prop}`, components[comp][prop]);
        });
      });
    }

    if (theme.isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [theme]);

  const toggleTheme = () => {
    if (!formConfig.themes.themeSwitcher.enabled) return;
    setCurrentThemeId(prev => prev === 'light' ? 'dark' : 'light');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, currentThemeId }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);